<template>
  <div class="form-group" :style="inputGroupStyle">
    <i class="icon" :class="icon" :style="iconStyle"/>
    <input
      :class="inputClass"
      @input="$emit('input',$event.target.value)"
      :placeholder="placeholder"
      :name="name"
      :type="type"
      :style="inputStyle"
    />
    <slot></slot>
  </div>
</template>
<script>
export default {
  name:'InputGroup',
  model: {
    prop: 'val',
    event: 'input'
  },
  props:[
    'val',
    'icon',
    'placeholder',
    'name',
    'type',
    'inputClass',
    'iconStyle',
    'inputGroupStyle',
    'inputStyle',
  ]

}
</script>

<style lang="less">
@border-color: #eaeaea;
@form-group-height: 40px;
.form-group {
    margin-top: 12px;
    border-radius: 4px;
    border: 1px solid @border-color;
    height: @form-group-height;
    line-height: @form-group-height;
    font-family: "Microsoft YaHei";
    display: flex;
    align-items: center;
    font-size: 14px;
    .icon {
      width: 23px;
      height: 23px;
      margin: 8px;
      background-size: cover;
      background-position: center center;
      float: left;
      &::after{
        clear: both;
        content: "";
      }
    }
    .icon-user {background-image: url('../../assets/icon-user.png')}
    .icon-pwd {background-image: url('../../assets/icon-pwd.png')}
    .icon-sms {background-image: url('../../assets/icon-sms.png')}
    .icon-check {background-image: url('../../assets/icon-check.png')}
    .i-icon-closeEye {background: url('../../assets/icon-close-eye.png') no-repeat center}
    .i-icon-openEye {background: url('../../assets/icon-open-eye.png') no-repeat center}
    input {
      height: 20px;
      line-height: 20px;
      background: transparent;
      outline: 0 none;
      color: #333;
      display: inline-block;
      width: 250px;
      font-size: 100%;
      vertical-align: middle;
      font-family: inherit;
      border:none;
      &.code{
        width:130px;
      }
    }
    .img-code{
      float: right;
      height: @form-group-height;
      width:100px;
      text-align: center;
      border-left: 1px solid @border-color;
      cursor: pointer;
      img{
        margin-top:2px;
        height: 36px;
        width: auto;
      }
    }
    .sms-code{
      float: right ;
      height: @form-group-height;
      width:100px;
      button{
        width: 98px;
        height: 34px;
        line-height: 34px;
        text-align: center;
        color: #3092fd;
        font-size: 12px;
        border: 1px solid #3092fd;
        border-radius: 5px;
        text-decoration: none;
        cursor: pointer;
        &:click{
          border-color:#3092fd;
        }
        &:focus{
          outline:none;
        }
      }
    }
    &.btn-group{
      margin-top:20px;
      border-color:transparent;
      button{
        background-image: linear-gradient(#2a6dff, #39c4fb);
        display: block;
        outline: 0 none;
        width: 100%;height: 100%;
        text-align: center;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        border: none;
        border-radius: 6px;
      }
    }
  }
  ._nc {
    padding:0;
    .stage1{
      height: @form-group-height  !important;
      padding: 0 !important;;
      .slider{
        width:100%;
        left: 0 !important;
        right: 0 !important;
      }
      .slider,.track div,.label,.button{
        height: @form-group-height  !important;
        line-height:@form-group-height  !important;
      }
      .icon{
        width: 20px;
        height: 20px;
        font-size: 22px;
        left: 14px;
        top: -2px;
      }
    }
    .stage3 {
      height: auto !important;
      .title{
        font-size: 12px !important;
        margin: 0 !important;
      }
    }
  }
</style>
